/**
 * Scholarships open to BIET students — supplied directly by the institute,
 * not transcribed from a public page (there isn't one that lists all of
 * these together). Where the source gave no link, none is shown rather than
 * guessed: a wrong URL for a scholarship portal is worse than none, since it
 * can send a student to someone else's application or nowhere at all.
 *
 * Two corrections from the source as supplied: "Ajeem premji Foundation" ->
 * "Azim Premji Foundation" (the org's actual name). The row given as "SBI
 * Asha Scharship.co.in/" was too garbled to safely split into a provider and
 * a URL, so it is carried with a name only.
 *
 * This replaces an earlier list scraped from bietdvg.edu/facilities/scholarship
 * (state/central sanctioning-office groups and two institute endowments) —
 * dropped in favour of this one, more current list, by request.
 */

/** The institute's own line introducing the list. */
export const SCHOLARSHIP_INTRO =
  "The following scholarships are available for needy and deserving students.";

/** A scholarship named with its own provider and (where published) a direct link. */
export interface Scholarship {
  name: string;
  provider?: string;
  /** Absent where the source gives no URL — never guessed. */
  link?: string;
  /** Free-text where the source gives an instruction instead of a link. */
  note?: string;
}

export const SCHOLARSHIPS: Scholarship[] = [
  { name: "National Post-Metric Scholarship", provider: "Govt. of India", link: "https://scholarships.gov.in/" },
  { name: "Central Sector Scheme (CSS)", provider: "Govt. of India" },
  { name: "AICTE Pragati / Saksham Scholarship", provider: "Govt. of India" },
  { name: "State Post-Metric Scholarship (Vidyasiri)", provider: "Govt. of Karnataka", link: "https://ssp.postmatric.karnataka.gov.in/" },
  { name: "ಮುಖ್ಯಮಂತ್ರಿ ರೈತ ವಿದ್ಯಾ ನಿಧಿ (Mukhyamantri Raitha Vidya Nidhi)", provider: "Govt. of Karnataka" },
  { name: "Karnataka Labour Welfare Board Scholarship", provider: "Govt. of Karnataka", link: "https://klwbapps.karnataka.gov.in/" },
  { name: "Reliance Foundation Scholarship", provider: "Reliance Foundation", link: "https://www.scholarships.reliancefoundation.org/" },
  { name: "Vidyadhan", provider: "S. Damodaran Trust", link: "https://www.vidyadhan.org/", note: "For students continuing this scholarship from PUC." },
  { name: "IEEE WIE Scholarship", provider: "IEEE", link: "https://wie.ieee.org/" },
  { name: "Jindal Trust Scholarship", provider: "Sitaram Jindal Foundation", link: "https://www.sitaramjindalfoundation.org/" },
  { name: "Parivartan", provider: "HDFC Bank", link: "https://www.parivartanecss.com/" },
  { name: "IDFC FIRST Scholarship", provider: "IDFC FIRST Bank", link: "https://firstimpactscholarships.idfcfirst.bank.in/helpPage" },
  { name: "Deepika Scholarship", provider: "Azim Premji Foundation", link: "https://azimpremjifoundation.org/" },
  { name: "SBI Asha Scholarship", provider: "SBI Foundation" },
  { name: "Aditya Birla Scholarship", provider: "Aditya Birla Group", link: "https://www.adityabirlascholars.net/the-scholarship/" },
  { name: "Muskaan Scholarship", provider: "Valvoline Cummins Pvt Ltd", link: "https://muskaan.synergieinsights.in/" },
  { name: "Bluestar Foundation Scholarship", provider: "Bluestar Foundation", link: "https://www.bluestarfoundation.in/" },
  { name: "Adani Gyan Jyoti Scholarship", provider: "Adani Group", link: "https://www.buddy4study.com/page/adani-gyan-jyoti-scholarship" },
  { name: "Legrand Empowering Scholarship", provider: "Group Legrand India", link: "https://legrandscholarship.co.in/" },
  { name: "Mirae Asset India Scholarship", provider: "Mirae Asset Foundation", link: "https://india.miraeasset.org/" },
  { name: "Vidyadhan Scholarship", provider: "LIC Housing Finance Ltd", link: "https://lichfl.scholarsbox.in/" },
  { name: "Kotak Kanya Scholarship", provider: "Kotak Education Foundation", link: "https://www.kotakeducationfoundation.org/" },
  { name: "Swami Dayanand Foundation Scholarship", provider: "Swami Dayanand Foundation", link: "https://www.swamidayanand.org/" },
  { name: "Dr. Shamanur Shivashankarappa Janakalyana Trust Scholarship", provider: "SS Trust", link: "https://ssjanakalyantrust.org/" },
  { name: "Foundation for Excellence Scholarship", provider: "Goel Family", link: "https://ffe.org/" },
  { name: "KSF Scholarship", provider: "KS Foundation", link: "https://ksfkarnataka.com/" },
  { name: "Vidya Chetana Scholarship", provider: "Youth for Seva", link: "https://vidyachetana.org/login" },
  { name: "Vidyasaarathi", provider: "Protean Technologies Ltd.", link: "https://www.vidyasaarathi.co.in/Vidyasaarathi/" },
  { name: "TVS Cheema Scholarship", provider: "TVS Cheema Foundation", link: "https://www.tvscsf.com/" },
  { name: "Eastman PowerUp EduSkill Scholarship", provider: "Eastman Auto and Power Limited", link: "https://www.buddy4study.com/article/eastman-powerup-eduskill-scholarship" },
  { name: "RH Trust Scholarship", provider: "Rajanahalli Family, Davangere", note: "Contact the Trust office in Davangere." },
  { name: "Karuna Jeevakalyana Trust Scholarship", provider: "Karuna Jeevakalyana Trust, Davangere" },
];

/** Every scholarship listed on the page. */
export const SCHOLARSHIP_COUNT = SCHOLARSHIPS.length;
